export default function decodeToken(token) {
	try {
		let tokenSplit = token?.split?.('.') || [];
		return JSON.parse(atob(tokenSplit[1]));
	} catch {
		return {};
	}
}
